export default __webpack_public_path__ + "static/074-1aec38a3c438d9fd4b23509e7f242712.jpg";